<template>
  <div>
    <ul class="timeline">
      <li v-for="(status, index) in data"
          :key="status.id"
          class="animated--grow-in"
          :class="index % 2 !== 0 ? 'timeline-inverted' : ''">
        <div class="timeline-badge shadow-sm" :class="`${status.status.label}`">
          <i :class="getIcon(status.status.id)"></i>
        </div>
        <div class="timeline-panel">
          <div class="timeline-heading">
            <span class="timeline-title title-color py-0">
              {{ getTranslation(status.status.status) }}
            </span>
            <div v-if="status.user_id">
              <small class="text-muted">
                <i :class="getOperatorsArray('user_id', status.user_id).length > 0 ? 'bx bx-support' : 'bx bx-user'"
                   class=" pr-1"></i>
                {{ getUserObject('id', status.user_id).name }}
              </small>
            </div>
            <div>
              <small class="text-muted">
                <i class="bx bx-calendar pr-1"></i>
                {{ status.created }}
              </small>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TicketStatuses",
  props: [
    'data'
  ],
  methods: {
    getTranslation(expression){
      if (expression === 'expression_135') {
        return this.getTranslations('expression_83')
      } else if (expression === 'expression_136') {
        return this.getTranslations('expression_246')
      } else if (expression === 'expression_137') {
        return this.getTranslations('expression_591')
      } else if (expression === 'expression_138') {
        return this.getTranslations('expression_29')
      } else if (expression === 'expression_139') {
        return this.getTranslations('expression_589')
      } else if (expression === 'expression_140') {
        return this.getTranslations('expression_368')
      } else if (expression === 'expression_141') {
        return this.getTranslations('expression_1088')
      } else if (expression === 'expression_142') {
        return this.getTranslations('expression_1089')
      } else if (expression === 'expression_143') {
        return this.getTranslations('expression_1090')
      } else if (expression === 'expression_144') {
        return this.getTranslations('expression_1091')
      } else if (expression === 'expression_145') {
        return this.getTranslations('expression_1092')
      } else if (expression === 'expression_207') {
        return this.getTranslations('expression_45')
      } else {
        return '---'
      }
    },
    getIcon(id){
      if (id === 0) {
        return 'bx bxs-time'
      } else if (id === 1) {
        return 'bx bxs-bot'
      } else if (id === 2) {
        return 'bx bx-window-close'
      } else if (id === 3) {
        return 'bx bxs-phone-call'
      } else if (id === 4) {
        return 'bx bx-pause-circle'
      } else if (id === 5) {
        return 'bx bx-link-alt'
      } else if (id === 6) {
        return 'bx bxs-message-check'
      } else if (id === 7) {
        return 'bx bx-transfer-alt'
      } else if (id === 8) {
        return 'bx bxs-x-circle'
      } else if (id === 9) {
        return 'bx bxs-phone-off'
      } else if (id === 10) {
        return 'bx bxs-user-x'
      } else if (id === 11) {
        return 'bx bxs-bell'
      } else {
        return 'bx bxs-time'
      }
    }
  }
}
</script>

<style>
.timeline {
  list-style: none;
  /*padding: 20px 0 20px;*/
  position: relative;
}
.timeline:before {
  /*top: 0;*/
  /*bottom: 0;*/
  top: 35px;
  bottom: 75px;
  position: absolute;
  content: " ";
  width: 3px;
  background-color: #eeeeee;
  left: 50%;
  margin-left: -1.5px;
}
.timeline > li {
  margin-bottom: 20px;
  position: relative;
}
.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}
.timeline > li:after {
  clear: both;
}
.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}
.timeline > li:after {
  clear: both;
}
.timeline > li > .timeline-panel {
  width: 43%;
  float: left;
  border: 1px solid #d4d4d4;
  border-radius: 15px;
  padding: 20px;
  position: relative;
  /*-webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);*/
  /*box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);*/
}
.timeline > li > .timeline-panel:before {
  position: absolute;
  top: 26px;
  right: -15px;
  display: inline-block;
  border-top: 15px solid transparent;
  border-left: 15px solid #ccc;
  border-right: 0 solid #ccc;
  border-bottom: 15px solid transparent;
  content: " ";
}
.timeline > li > .timeline-panel:after {
  position: absolute;
  top: 27px;
  right: -14px;
  display: inline-block;
  border-top: 14px solid transparent;
  border-left: 14px solid #fff;
  border-right: 0 solid #fff;
  border-bottom: 14px solid transparent;
  content: " ";
}
.timeline > li > .timeline-badge {
  color: #fff;
  width: 50px;
  height: 50px;
  line-height: 52px;
  font-size: 1.4em;
  text-align: center;
  position: absolute;
  top: 16px;
  left: 50%;
  margin-left: -25px;
  background-color: #999999;
  z-index: 100;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
}
.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}
.timeline > li.timeline-inverted > .timeline-panel:before {
  border-left-width: 0;
  border-right-width: 15px;
  left: -15px;
  right: auto;
}
.timeline > li.timeline-inverted > .timeline-panel:after {
  border-left-width: 0;
  border-right-width: 14px;
  left: -14px;
  right: auto;
}
.timeline-badge.primary {
  background-color: #2e6da4 !important;
}
.timeline-badge.success {
  background-color: #3f903f !important;
}
.timeline-badge.warning {
  background-color: #f0ad4e !important;
}
.timeline-badge.danger {
  background-color: #d9534f !important;
}
.timeline-badge.info {
  background-color: #5bc0de !important;
}
.timeline-title {
  margin-top: 0;
}
.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
}
.timeline-body > p + p {
  margin-top: 5px;
}
@media (max-width: 767px) {
  ul.timeline:before {
    left: 40px;
  }
  ul.timeline > li > .timeline-panel {
    width: calc(100% - 90px);
    width: -moz-calc(100% - 90px);
    width: -webkit-calc(100% - 90px);
  }
  ul.timeline > li > .timeline-badge {
    left: 15px;
    margin-left: 0;
    top: 16px;
  }
  ul.timeline > li > .timeline-panel {
    float: right;
  }
  ul.timeline > li > .timeline-panel:before {
    border-left-width: 0;
    border-right-width: 15px;
    left: -15px;
    right: auto;
  }
  ul.timeline > li > .timeline-panel:after {
    border-left-width: 0;
    border-right-width: 14px;
    left: -14px;
    right: auto;
  }
}
</style>
